import React from 'react';

const GlobeIcon: React.FC = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8C14.6667 4.31811 11.6819 1.33334 8 1.33334C4.31811 1.33334 1.33334 4.31811 1.33334 8C1.33334 11.6819 4.31811 14.6667 8 14.6667Z"
      stroke="#1f1f1f"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.33334 8H14.6667"
      stroke="#1f1f1f"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 1.33334C9.65686 3.15892 10.6141 5.52796 10.6667 8.00001C10.6141 10.4721 9.65686 12.8411 8 14.6667C6.34314 12.8411 5.38596 10.4721 5.33333 8.00001C5.38596 5.52796 6.34314 3.15892 8 1.33334Z"
      stroke="#1f1f1f"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default GlobeIcon;
